export default {
  postureReport: "تقرير الموقف",
  postureData: "بيانات الموقف",
  postureDataContrast: "مقارنة بيانات الموقف",
  postureRiskContrast: "مقارنة مخاطر الموقف",
  postureDataTrend: "اتجاه بيانات الموقف",
  postureRiskTrend: "اتجاه مخاطر الموقف",
  postureLogData: "بيانات سجل الوضعية",
  lateralhead: "انحراف الرأس الجانبي",
  unevenshoulder: "الكتفين غير المتكافئين",
  scoliosis: "ال skoliosis",
  unevenhip: "انحراف جانبي الحوض",
  xleg: "الساق على شكل X",
  oleg: "الساق على شكل O",
  roundedshoulder: "الكتف المستدير",
  kneehyperextension: "فرط التمدد في الركبة",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "الرأس إلى الأمام",
  toTheLeft: "(يسار)",
  toTheRight: "(يمين)",
  bracketsLeft: "(L)",
  bracketsRight: "(R)",
  bracketsNormal: "(طبيعي)",
  leg: "الساقين",
  legLeft: "الساقين (L)",
  legRight: "الساقين (R)",
  riskAssessment: "تقييم المخاطر",
  muscleState: "حالة العضلات",
  muscleStateDesc: "لم يتم العثور على أي حالة عضلية غير طبيعية",
  testTime: "وقت الاختبار",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "العنصر",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "صورة مواريه",
  lAbnormalRisk: "مخاطر L",
  mAbnormalRisk: "مخاطر M",
  hAbnormalRisk: "مخاطر H",
  highRisk: "مخاطر عالية",
  riskAnalysis: "تحليل المخاطر",
  conclusionRecommendation: "استنتاج التوصيات",
  solution: "الحل",
  movePosition: "انقر على النقطة لتحريك الموقف",
  confirmTheClose: "لم يتم الحفظ بعد، هل تؤكد الإغلاق؟",
  closeInfo: "لم يتم الحفظ بعد، هل تؤكد الإغلاق؟",
  share: "مشاركة",
  front: "المقدمة",
  side: "الجانب",
  back: "الخلف",
  otherSide: "الجانب الآخر",
  points: "النقاط",
  angle: "الزاوية",
  name: "الاسم",
  gender: "الجنس",
  male: "ذكر",
  female: "أنثى",
  age: "العمر",
  year: "سنوات",
  height: "الطول",
  weight: "الوزن",
  time: "الوقت",
  patientId: "رقم المريض",
  save: "حفظ",
  saveModify: "حفظ التعديل",
  print: "طباعة",
  cancel: "إلغاء",
  zoomIn: "تكبير",
  zoomOut: "تصغير",
  ok: "موافق",
  return: "عودة",
  empty: "",
  unknown: "مجهول",
  succeedToCopy: "تم النسخ بنجاح",
  succeedToSave: "تم الحفظ بنجاح",
  headForwardDistance: "مسافة الرأس إلى الأمام",
  pelvisForwardTilt: "انحراف الحوض للأمام",
  wristHipDistanceLeft: "مسافة المعصم إلى الورك (اليسار)",
  wristHipDistanceRight: "المسافة بين المعصم والورك (اليمين)",
  evaluator: "المُقيّم",
  reportDate: "تاريخ التقرير",
  introduction: "المقدمة",
  doctorIntroDefault: "المجال المهني: طب إعادة التأهيل، تقييم وتصحيح الوضعية | سنوات الخبرة: أكثر من 5 سنوات | التخصص: إعادة تأهيل إصابات الرياضة، تصحيح الوضعية، إدارة الألم",
  recoveryLog: "سجل التعافي",
  returnToReport: "العودة إلى التقرير",
  loading: "جار التحميل...",
  showToolbox: "إظهار صندوق الأدوات",
  hideToolbox: "إخفاء صندوق الأدوات",
};

